/**
 * Catálogo do domínio `sgi` (T52, CAT-01).
 *
 * Origem: `src/shared/autorizacao/sgi.ts`.
 *
 * Segue o padrão de `juridico`: as duas concessões por relação sobre
 * `TicketInteracao` (`sgi.ts:19,22`) estão **fora** de qualquer `temPermissao`.
 * Quem é o responsável pela interação interage nela, com papel ou sem.
 *
 * `readAcoes` em `TicketSgi` (`sgi.ts:8`) também é de base: qualquer autenticado
 * lê as ações do ticket.
 */
import type { Concessao, NomePapel, Papel } from "../catalogo/vocabulario";

export const CONCESSOES_BASE_SGI: readonly Concessao[] = [
  { acoes: ["readAcoes"], recurso: "TicketSgi" },
  {
    acoes: ["delete", "Interagir"],
    recurso: "TicketInteracao",
    exigeRelacao: ["responsavel"],
  },
  {
    acoes: ["Interagir"],
    recurso: "TicketInteracao",
    exigeRelacao: ["responsavel_registro"],
  },
];

export const PAPEIS_SGI = {
  "sgi.admin": {
    dominio: "sgi",
    nivel: "admin",
    concessoes: [{ acoes: ["manage"], recurso: "TicketSgi" }],
  },
  "sgi.escrita": {
    dominio: "sgi",
    nivel: "escrita",
    concessoes: [{ acoes: ["read", "aceitaInteracao", "edit"], recurso: "TicketSgi" }],
  },
  "sgi.leitura": {
    dominio: "sgi",
    nivel: "leitura",
    concessoes: [{ acoes: ["read"], recurso: "TicketSgi" }],
  },
} as const satisfies Partial<Record<NomePapel, Papel>>;
